<template>
  <footer class="footer">
    <div class="service-intro">
      <div class="servece-left">
        <img :src="require('@/assets/img/logo2.png')" alt=""  @click="myIndex">
        <div class="desc">
          公司致力于打造全球装修建材智慧供应链平台，服务于房东、装修队长、装修公司，主要提供装修设计、辅材、主材等一站式建材采购、配送以及售后服务；为广大装修用户在装房子过程中提供方便，满足对装修产品的各种需求，方便快捷。
        </div>
        <div class="bei">
          <a href="http://beian.miit.gov.cn" target="_blank">苏ICP备2021029883号</a> 
        </div>
      </div>
      <div class="servece-type">
        <div class="servece-type-title">
          |&nbsp;&nbsp;关于我们
        </div>
        <div class="servece-type-info">
          <ul>
            <li v-for="(item, i) in menuList" :key="item">
              <router-link :to="'/about/'+ i">{{item}}</router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="servece-type servece-type-partners">
        <div class="servece-type-title">
          <span>|&nbsp;&nbsp;合作伙伴</span>
          <div class="right" v-if="pages>1">
            <Icon type="ios-arrow-dropleft-circle" @click="prePage" />
            <span class="num">{{current}}/{{pages}}</span>
            <Icon type="ios-arrow-dropright-circle" @click="nextPage" />
          </div>
        </div>
        <div class="servece-type-info">
          <!-- 8个分页 -->
          <div class="servece-type-info-img" v-for="(item, i) in partnersList" :key="i" @click="gotoPartner(item)">
            <img :src="item.logoUrl" alt="">
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { getPartnersList } from '@/api/home'
export default {
  name: 'Footer',
  data () {
    return {
      partnersList: [],
      current: 1,
      pages: 0,
      menuList : {
        1: '公司简介',
        2: '联系我们',
        4: '隐私政策'
      },
    }
  },
  created() {
    this.loadPartnersList()
  },
  methods: {
    prePage() {
      if(this.current <= 1) return
      this.current --
      this.loadPartnersList()
    },
    nextPage() {
      if(this.current >= this.pages) return
      this.current ++
      this.loadPartnersList()
    },
    loadPartnersList() {
      getPartnersList({
        current: this.current,
        size: 8
      }).then(res => {
        this.partnersList = res.records
        this.pages = res.pages
      })
    },
    gotoPartner(item){
      item.hrefUrl && window.open(item.hrefUrl)
    },
    myIndex() {
      window.scrollTo(0, 0)
      this.$router.push('/')
    }
  },
};
</script>

<style lang="less" scoped>
/*****************************底 部 开 始*****************************/
.footer {
  width: 100%;
  min-width: @page-main-width;
  // margin-top: 30px;
  background: #1F1F1F;
  color: #999;
  position: absolute;
  bottom: 0;
}
.service-intro {
  margin: 0 auto;
  height: 221px;
  width: @page-main-width;
  display: flex;
  align-items: center;
}

.servece-left {
  width: 40%;
  font-size: 12px;
  position: relative;
  top: -20px;
  
  img {
    width: 160px;
    position: relative;
    left: -22px;
    cursor: pointer;
  }
  .desc {
    margin: 0 0 20px 0;
  }
}
.servece-type {
  height: 166px;
  margin-left: 60px;

  .servece-type-title{
    font-size: 16px;
    line-height: 28px;
    font-weight: bold;
    color: #FFF;
    margin-bottom: 15px;
  }
  .servece-type-info ul {
    list-style: none;
  }
  .servece-type-info li {
    cursor: pointer;
    font-size: 14px;
    line-height: 26px;
    color: #999;
    margin-bottom: 15px;
    padding-left: 15px;
    a {
      color: #999;
    }
  }

  &:last-of-type {
    flex: 1;
  }

  &.servece-type-partners {
    .servece-type-title{
      display: flex;
      justify-content: space-between;

      .right {
        font-weight: normal;
        font-size: 12px;
        color: #999;

        display: flex;
        align-items: center;

        .num{
          padding: 0 5px;
        }
      }
    }

    .servece-type-info {
      overflow: hidden;
      .servece-type-info-img{
        cursor: pointer;
        float: left;
        width: 23%;
        margin-right: 10px;
        img {
          width: 100%;
          height: 50px;
          margin-bottom: 10px;
        }
      }
    }
  }
}

.bei {
    a, a:hover {
      color: #999;
      text-decoration: none;
  }
}
/*****************************底 部 结 束*****************************/
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue